// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__3_cJu","messages":"Chat_messages__1ianf","dateDivider":"Chat_dateDivider__251ck"};